import * as React from "react";

import type { Space } from "../../../../../types/spaces.types";

type SpaceEditorLayoutProps = {
  space: Space;
  children: React.ReactNode;
};

const SpaceEditorLayout = ({ space, children }: SpaceEditorLayoutProps) => {
  return (
    <div className="space-editor-page">
      {space.status === "DRAFT" && (
        // Status bar
        <div className="tw-fixed tw-top-72 tw-left-0 tw-w-full tw-h-8 tw-bg-gray-200 tw-overflow-hidden">
          <div
            className="tw-h-full tw-bg-purple-600"
            style={{ width: `${space.completion_percentage}%` }}
            role="progressbar"
            aria-valuenow={space.completion_percentage}
            aria-valuemin={0}
            aria-valuemax={100}
          />
        </div>
      )}
      <div className="tw-py-64">{children}</div>
    </div>
  );
};

export { SpaceEditorLayout, type SpaceEditorLayoutProps };
